import { Directive, ElementRef } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';

@Directive({
  selector: '[appBgImage]'
})
export class BgImageDirective {
  private competitionChanged: Observable<boolean>;
  private el: ElementRef;
  private subscription: Subscription;
  constructor() {
    // this.el.nativeElement.style.background
    this.subscription = this.competitionChanged.subscribe((value) => {
      this.el.nativeElement.style.background = value, console.log('fullscreen schanged', value);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/directives/bg-image.directive.ts